import { useEffect, useState } from 'react';
import { ITariffBitmapItem } from '../../../../../entities/tariff/api/types';

export const usePublishTariffSelected = () => {
	const [currentPermission, setCurrentPermission] = useState<number>(0);
	const [selectedTariffs, setSelectedTariffs] = useState<ITariffBitmapItem[]>([]);

	const selectTariff = (tariff: ITariffBitmapItem) => {
		const permission = currentPermission | (1 << tariff.bitPosition);

		setSelectedTariffs(prev => [...prev, tariff]);
		setCurrentPermission(permission);
	};

	const selectTariffs = (tariffs: ITariffBitmapItem[]) => {
		setSelectedTariffs(prev => {
			const newTariffs = tariffs.filter(tariff => !selectedTariffs.some(el => el.tariff === tariff.tariff));
			const newPermission = newTariffs.reduce(
				(acc, tariff) => acc | (1 << tariff.bitPosition),
				currentPermission,
			);
			setCurrentPermission(newPermission);
			return [...prev, ...newTariffs];
		});
	};

	// * Сбрасывает права при отсутствии выбранных тарифов
	useEffect(() => {
		if (selectedTariffs.length === 0) {
			setCurrentPermission(0);
		} else {
			const newPermission = selectedTariffs.reduce((acc, tariff) => acc | (1 << tariff.bitPosition), 0);
			setCurrentPermission(newPermission);
		}
	}, [selectedTariffs]);

	const removeTariff = (tariff: ITariffBitmapItem) => {
		const permission = currentPermission & ~(1 << tariff.bitPosition);

		setSelectedTariffs([...selectedTariffs.filter(el => el.tariff !== tariff.tariff)]);
		setCurrentPermission(permission);
	};

	const cleanTariffs = () => setSelectedTariffs([]);

	return {
		selectTariff,
		selectTariffs,
		removeTariff,
		cleanTariffs,
		selectedTariffs,
		currentPermission,
	};
};
